import React, { Component } from 'react'
import css from './index.scss'

export default class LoadTypeChip extends Component {
  state = {}
  render() {
    const type = this.props.type?.toLowerCase()
    const deliveryType = this.props.deliveryType?.toLowerCase()

    let label = 'Fixo'
    let className = 'loadNormal'

    switch (type) {
      case 'quotation':
        label = 'Cotação'
        className = 'loadQuote'
        break
      case 'auction':
        label = 'Leilão'
        className = 'loadAuction'
        break
      case 'rank_table':
        label = 'Ranking'
        className = 'ranking'
        break
      default:
        switch (deliveryType) {
          case 'lot':
            label = 'Lote'
            className = 'loadBatch'
            break
        }
    }
    return (
      <span style={{ marginTop: 4, marginRight: 16 }} className={css[className]}>
        {label}
      </span>
    )
  }
}
